import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Alert } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import { useAuth } from '../context/AuthContext';
import { colors, spacing, typography } from '../styles/globalStyles';

export default function AccountMenu() {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const navigation = useNavigation();
  const { signOut } = useAuth();

  const handleLogout = async () => {
    try {
      setIsMenuVisible(false);
      await signOut();
    } catch (error: any) {
      Alert.alert('Error', error.message);
    }
  };

  const confirmLogout = () => {
    Alert.alert(
      'Logout',
      'Are you sure you want to logout?',
      [
        {
          text: 'Cancel',
          style: 'cancel',
        },
        {
          text: 'Logout',
          onPress: handleLogout,
          style: 'destructive',
        },
      ]
    );
  };

  const handleProfilePress = () => {
    setIsMenuVisible(false);
    navigation.navigate('Profile' as never);
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        onPress={() => setIsMenuVisible(!isMenuVisible)}
        style={styles.menuButton}
        activeOpacity={0.7}
      >
        <Ionicons
          name="person-circle-outline"
          size={28}
          color={colors.primary}
        />
      </TouchableOpacity>

      {isMenuVisible && (
        <View style={styles.menuContainer}>
          <TouchableOpacity
            style={styles.menuItem}
            onPress={handleProfilePress}
            activeOpacity={0.7}
          >
            <Ionicons
              name="person-outline"
              size={20}
              color={colors.text.primary}
              style={styles.menuIcon}
            />
            <Text style={styles.menuText}>Profile</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.menuItem}
            onPress={confirmLogout}
            activeOpacity={0.7}
          >
            <Ionicons
              name="log-out-outline"
              size={20}
              color={colors.text.primary}
              style={styles.menuIcon}
            />
            <Text style={styles.menuText}>Logout</Text>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginRight: spacing.md,
    zIndex: 1000,
  },
  menuButton: {
    padding: spacing.xs,
  },
  menuContainer: {
    position: 'absolute',
    top: 45,
    right: 0,
    backgroundColor: colors.surface,
    borderRadius: 8,
    padding: spacing.xs,
    minWidth: 150,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: spacing.sm,
    borderRadius: 4,
  },
  menuIcon: {
    marginRight: spacing.sm,
  },
  menuText: {
    ...typography.body,
    color: colors.text.primary,
  },
}); 